

export let PROXIES = {
  // gateway: 'http://10.12.1.161:8000/',
  gateway: 'https://svc2.primezim.flexbet-software.com/',
  Rabbit_Address: 'wss://svc1.betjapa.flexbet-software.com/ws2',
  data: 'https://svc2.primezim.flexbet-software.com/',

};
export const Contact = {
  tel: '+216 36 38 68 25',
  email: 'contact@bet216.tn',
  fax: '+216 36 38 68 25',
  addresse: 'Immeuble le 45,Bloc A 3eme Etage Bureau A 3.3 , Rue du Japon , Montplaisir 1073- Tunis-Tunisie'
};
export let EndPoints = {
  // http://10.12.1.161:5530/sr%3Asport%3A1/games?status=true&date=1575281771709&limit=25
  data: 'gameList/dashboard/'
};
